<script setup lang="ts">
import {TestSubQuestion} from "@/types";
import {getQuestionType, getTimeStr} from "@/utils/common.ts";
import {Edit} from "@element-plus/icons-vue";
import {nextTick, ref, watch} from "vue";
const problemTitle = ref()
const props = defineProps<{
  title: string,
  item: TestSubQuestion
}>()

const emit = defineEmits(["editSubQuestion"])

const onEditSubQuestion = () => {
  emit('editSubQuestion')
}

watch(
    () => props.item?.problem,
    (_) => {
      nextTick(() => {
        if (problemTitle.value) {
          renderMathInElement(problemTitle.value)
        }
      })
    }
)
</script>

<template>
  <!-- 子题 -->
  <el-descriptions :column="3" border class="mt-1rem" :title="title">
    <el-descriptions-item label="ID" :span="1">{{ item.id }}</el-descriptions-item>
    <el-descriptions-item
        :span="2"
        label="题目类型">
      {{
        getQuestionType(item.type)
      }}
    </el-descriptions-item>
    <el-descriptions-item label="标题" :span="3">
      <div ref="problemTitle">
        {{ item.problem }}
      </div>
    </el-descriptions-item>
    <el-descriptions-item
        :span="3"
        label="题目图片"
        v-if="item.image"
    >
      <el-image
          style="width: 7.5rem; height: 7.5rem"
          :src="image"
          :zoom-rate="1.2"
          :max-scale="7"
          :min-scale="0.2"
          :preview-src-list="item.image.split(',')"
          :initial-index="sIndex"
          fit="cover"
          class="mr-1rem rounded"
          v-for="(image, sIndex) in item.image.split(',')"
      />
    </el-descriptions-item>
    <el-descriptions-item
        :span="3" label="选项"
        v-if="(item.type === 1 || item.type === 2 || item.type === 5) && item.answer">
      <template v-for="(subItem, sIndex) in item.answer">
        <div class="bg-#f6f7f9 px-.5rem my-.5rem border-#D9D9D9 border-dashed border-.5px">
          {{ `${String.fromCharCode(sIndex + 65)}、${subItem}` }}
        </div>
      </template>
    </el-descriptions-item>
    <el-descriptions-item :span="3" label="正确答案">
      {{ item.right_answer }}
    </el-descriptions-item>
    <el-descriptions-item :span="3" label="解析">
      {{ item.parsing || `暂无解析~` }}
    </el-descriptions-item>
    <el-descriptions-item
        :span="3"
        label="答案图片"
        v-if="item.right_answer_image"
    >
      <el-image
          style="width: 7.5rem; height: 7.5rem"
          :src="image"
          :zoom-rate="1.2"
          :max-scale="7"
          :min-scale="0.2"
          :preview-src-list="item.right_answer_image.split(',')"
          :initial-index="sIndex"
          fit="cover"
          class="mr-1rem rounded"
          v-for="(image, sIndex) in item.right_answer_image.split(',')"
      />
    </el-descriptions-item>
    <el-descriptions-item
        label="创建时间"
        v-if="item.create_time"
    >
      {{ getTimeStr(item.create_time * 1000) }}
    </el-descriptions-item>
    <el-descriptions-item :span="3" label="编辑">
      <el-button type="primary" :icon="Edit" @click="onEditSubQuestion">编辑</el-button>
    </el-descriptions-item>
  </el-descriptions>
</template>

<style scoped>

</style>